/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {useState, useMemo} from "react";
import { MutableList } from "./MutableList";
import {service as PermissionService} from "../../../Services/PermissionService";
import {useSortedData} from "../../../Hooks/ListHooks";
import {useEffectPromise} from "../../../Hooks/EffectHooks";

export const StreamBankUserPermissionList = (props) => {
    const {
        RootData,
        Type,
        Data,
        sortKey,

        AddItem=((item) => {}),
        RemoveItem=((itemOrKey) => {}),
        UpdateItem=((itemOrKey) => {}),
        UpdateItems=((items = []) => {}),
    } = props;
    
    const primaryKeyName = "permissionId";
    
    // these are all of the Permissions which have a permissionType of code 'user'
    const [permissions, setPermissions] = useState(null);
    
    // TODO: this could be changed to use usePrimeCache and .CachedValues()?
    useEffectPromise(
        async () => (await PermissionService.GetPermissions('user'))?.result,
        (result) => {
            if(result) {
                setPermissions(result);
            }
        }, [],
        true
    );
    
    const assignedPermissions = useSortedData(Data, sortKey) ?? [];
    
    // This is an array of Permissions with the UserPermissions
    // fields mixed in and a 'value' property added.
    const assignedUserPermissions = useMemo(() => {
        return permissions?.map?.((permission) => {
            const userPermission = assignedPermissions.find(x => Number(x[primaryKeyName]) === Number(permission[primaryKeyName]));
            return {
                ...permission,
                userPermissionId: userPermission?.userPermissionId,
                _tempId: userPermission?._tempId,
                userId: RootData?.userId,
                value: userPermission ? 1 : 0,
            }
        });
    }, [assignedPermissions, JSON.stringify(permissions), RootData?.userId]);
    
    const onToggleCheckbox = (value) => {
        // we can't use `key` here because we override PrimaryKeyName
        // below in the <MutableList> to use permissionId,
        // but RemoveItem of ChildrenFiledEditor uses the PK
        // from the model of the association (UserPermission) and
        // looks for permission.userPermissionId.
        // So instead I'm looking up the checked-state from the
        // merged assignedUserPermissions array with value.permissionId
        // and handling it appropriately from there.
        const { userId, permissionId } = value;
        const existingUserPermission = assignedUserPermissions.find(x => Number(x.permissionId) === Number(permissionId));
        if (existingUserPermission?.value) {
            RemoveItem(value); //existingUserPermission.userPermissionId ?? existingUserPermission._tempId);
        } else {
            AddItem(value); //{ userId, permissionId });
        }
    };
    
    return <MutableList
        {...props}
        Data={assignedUserPermissions}
        UpdateItem={onToggleCheckbox}
        PrimaryKeyName={primaryKeyName}
        // This control doesn't allow manual add/remove of rows 
        AddItemButton={false}
        RemoveItemButton={false}
    />;
};
